export function getView(currentTab, expectedTab, featureFlagOn) {
  console.log({ currentTab, expectedTab, featureFlagOn })
  return currentTab === expectedTab && featureFlagOn
}
